import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import type { MetaContent } from "@@/shared/meta-content/meta-content";
import type { Except } from "type-fest";
import type { ResourceReferenceId } from "../resource-references/resource-reference-id";
import type { ResourceId } from "../resources/resource-id";
import type { BookableOptionId } from "./bookable-option-id";
import { bookableOptionIdFactory } from "./bookable-option-id";
import type { ManifestFieldType } from "./manifest-field-type";

type ManifestBookableOption = {
    readonly _id: BookableOptionId;
    readonly _type: "MANIFEST_BOOKABLE_OPTION";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly resourceReferenceId: ResourceReferenceId;
    readonly resourceId: ResourceId;
    readonly meta: MetaContent;
    readonly parentId: BookableOptionId;
    readonly fields: ManifestFieldType[];
};

type CreateManifestBookableOptionParams = Except<
    ManifestBookableOption,
    "_id" | "_type" | "_createdAt"
> & { _id?: BookableOptionId };

const createManifestBookableOption = (
    params: CreateManifestBookableOptionParams,
): ManifestBookableOption => {
    return {
        ...params,
        _id: params._id || bookableOptionIdFactory(),
        _type: "MANIFEST_BOOKABLE_OPTION",
        _createdAt: nowIsoAndUnix(),
    };
};
export { createManifestBookableOption };
export type { ManifestBookableOption };
